import { useState, useEffect, useCallback } from 'react';

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState(null); 
  const [loading, setLoading] = useState(true);

  const fetchUserInfo = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/user-info`, {
        method: 'GET',
        credentials: 'include'
      });
      
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('🔍 useUserInfo: Response not ok:', response.status, errorText);
        throw new Error(`Failed to fetch user info: ${response.status} ${errorText}`);
      }
      
      const data = await response.json();

      if (data.success) {
        // Set the complete userInfo object with all fields from the response
        setUserInfo(data);
        setError(null);
      } else {
        throw new Error(data.message || 'Failed to fetch user info');
      }
    } catch (error) {
      console.error('🔍 useUserInfo error:', error);
      setError(error.message);
    } finally {
      setLoading(false); 
    }
  }, []);

  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo]);

  const refreshUserInfo = useCallback(() => {
    setLoading(true);
    fetchUserInfo();
  }, [fetchUserInfo]);

  return { userInfo, error, loading, refreshUserInfo }; 
};

export default useUserInfo;
